const items = [
  "Brest",
  "Quimper",
  "Morlaix",
  "Aéroport Brest Bretagne",
  "Gare TGV Brest",
  "Presqu'île de Crozon",
  "Roscoff",
  "Concarneau",
  "Service sur mesure 24/7",
];

const Diamond = () => (
  <span
    className="inline-block w-[7px] h-[7px] bg-[#c9a84c] rotate-45 mx-8 md:mx-12 flex-shrink-0"
    aria-hidden="true"
  />
);

export const MarqueeSection = () => {
  const row = [...items, ...items, ...items];

  return (
    <section
      data-testid="editorial-marquee"
      className="bg-[#1a1d2e] border-y border-[#c9a84c]/10 py-6 md:py-7 overflow-hidden"
      aria-label="Destinations desservies"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, idx) => (
              <span key={`${half}-${idx}`} className="flex items-center whitespace-nowrap">
                <span
                  className="text-[22px] md:text-[30px] uppercase tracking-[0.12em] text-[#c9a84c]/75"
                  style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                >
                  {item}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
